module.exports = __webpack_public_path__ + "img/ef47999.jpeg";